import axios from "axios"
import { Dispatch } from "redux"
import { MainAction, MainActionTypes } from "../types/Main"

// https://v2.jokeapi.dev/joke/Programming
// https://geek-jokes.sameerkumar.website/api?

export const fetchMain = () => {
   return async (dispatch: Dispatch<MainAction>) => {
      try {
         dispatch({ type: MainActionTypes.FETCH_MAIN })
         const response = await axios.get(`https://geek-jokes.sameerkumar.website/api?`)
         setTimeout(() => {
            dispatch({
               type: MainActionTypes.FETCH_MAIN_SUCCESS,
               payload: response.data
            })
         }, 500)
      } catch (error) {
         dispatch({
            type: MainActionTypes.FETCH_MAIN_ERROR,
            payload: "Error"
         })
      }
   }
}




